import axios, { AxiosRequestConfig } from 'axios';
import config from '../constants/constants';

/**
 *  Logs in a user by exchanging a UUID for authentication tokens.
 *
 * @param uuid - The UUID to exchange for authentication tokens.
 * @returns Returns accessToken and wanted document
 */
export const loginExchange = async (uuid: string) => {
  const options: AxiosRequestConfig = {
    method: 'POST',
    url: `${config.serverURL}/auth/exchange`,
    data: { uuid }
  };

  const response = await axios(options);

  return response;
};
